<div
  *transloco="let t; read: 'configurations.clone-dialog'"
  class="xi-modal__container clone-configuration__container"
>
  <h2 class="xi-modal__title">{{ t('title') }}</h2>
  <form [formGroup]="cloneConfigForm" (ngSubmit)="clone()">
    <div class="xi-modal__content clone-configuration__content">
      <div>
        <p [innerHTML]="t('content', { originalConfiguration: originalConfig.name })"></p>

        <div class="clone-configuration__name">
          <xi-input-field
            [label]="t('clone-name')"
            [placeholder]="t('enter-here')"
            [prePopulateStatus]="true"
            formControlName="configName"
            icon="cancel"
            [status]="configNameStatus"
            (onIconClick)="cloneConfigForm.patchValue({ configName: '' })"
            required
          ></xi-input-field>
        </div>
      </div>
    </div>
    <div class="xi-modal__actions clone-configuration__actions">
      <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

      <div class="xi-loader-button-container">
        <xi-default-button
          [text]="t('confirm')"
          type="submit"
          [disabled]="cloneConfigForm.invalid || cloneConfigForm.status === 'PENDING'"
        >
        </xi-default-button>

        @if (cloneConfigForm.status === 'PENDING') {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  </form>
</div>
